import React from "react";
import { useState } from "react";
import { Container, Col, Row } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsTable } from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { numberWithCommas } from "../../utils/customFunction";
import { getFundsByAmcCodeForUnitholderPortfolio } from "../../stores/services/funds.service";
import {
  getAllUnitHoldersByAmc,
  getUnitHoldersByAmcAndFolioNo,
} from "../../stores/services/unit-holder.service";
import Select from "react-select";
import { useSelector } from "react-redux";
import moment from "moment";

const UnitholderPortfolio = () => {
  const amc_name = sessionStorage.getItem("amc_name") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const email = sessionStorage.getItem("email") || "";
  const [loading, setLoading] = useState(false);
  const [unitLoading, setUnitLoading] = useState<boolean>(false);

  const [allAmc, setAllAmc] = useState<any>([]);
  const [Amc, setAmc] = useState("");
  const [allFunds, setAllFunds] = useState<any>([]);

  const [amcError, setAmcError] = useState("");
  const [allFolios, setAllFolios] = useState<any>([]);
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

  React.useEffect(() => {
    const getFundByAMcCode = async (code: string) => {
      setLoading(true);
      allFunds.length = 0;
      setAllFunds(allFunds);

      //get funds by amc for dropdown
      try {
        const response = await getFundsByAmcCodeForUnitholderPortfolio(
          email,
          code,
          // fund_code?.length > 0 ? fund_code : ""
          ""
        );
        // sort data
        let sortedData: any = [];
        sortedData = response.data.data.sort(function (a, b) {
          let x = a.nature.toLowerCase();
          let y = b.nature.toLowerCase();
          if (x > y) {
            return 1;
          }
          if (x < y) {
            return -1;
          }
          return 0;
        });
        // setAllFunds(response.data.data);
        setAllFunds(sortedData);

        setLoading(false);
      } catch (error) { }
    };
    const getAllFolios = async () => {
      try {
        const response = await getAllUnitHoldersByAmc(email, amc_code);
        if (response.data.status == 200) {
          setAllFolios(response.data.data);
        }
      } catch (error) { }
    };
    getAllFolios();
    getFundByAMcCode(amc_code);
  }, []);

  const getUnitHoldersByAmcFolioNo = async (email, folio_no) => {
    try {
      if (amc_code === "") {
        setAmcError("required-border");
      } else {
        setLoading(true);
        const response = await getUnitHoldersByAmcAndFolioNo(
          email,
          amc_code,
          //   amc_code + "-" + folio_no
          folio_no
        );
        if (response.data.status === 200) {
          if (response.data.data.length > 0) {
            await portfolio(response.data.data);
          } else {
            setTotalAmount("");
            setUnits("");
            setSelected([]);
            toast.error("Data not found.");
          }
        } else {
          toast.error(response.data.message);
        }
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      if (error.response !== undefined) {
        toast.error(error.response.data.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };

  const renderAllFoliosDropdown = () => {
    return allFolios.map((item: any, index: number) => {
      return {
        label: `${item.folio_no?.replace("UNITHOLDER_", "")} - (${item.name})`,
        reinvest: item.reinvest?.toString() || "false",
        name: item.name,
        value: item.folio_no?.replace("UNITHOLDER_", ""),
      };
    });
  };

  const portfolio = (data) => {
    if (
      data[0].balance_unit !== "" &&
      data[0].balance_unit !== "[]" &&
      data[0].balance_unit !== undefined
    ) {
      let unitBlance = JSON.parse(data[0].balance_unit);
      let unit = 0;
      let amount = 0;

      unitBlance.map((item, index) => {
        let fName = "";
        unit =
          unit +
          parseFloat(
            item.fund_unit ? item.fund_unit.toString().replaceAll(",", "") : "0"
          );
        amount =
          amount +
          parseFloat(
            item.fund_unit ? item.fund_unit.toString().replaceAll(",", "") : "0"
          ) *
          parseFloat(
            allFunds
              .find((fund) => fund.symbol_code === item.fund_code)
              ?.navData?.nav.toFixed(4) || "0"
          );
        // parseFloat(
        //   item.nav ? item.nav.toString().replaceAll(",", "") : "0"
        // );
        allFunds.map((elem) => {
          if (elem.symbol_code === item.fund_code) {
            fName = elem.fund_name;
          }
        });
        unitBlance[index].fund_name = fName;
      });

      setTotalAmount(amount.toFixed(2));
      setUnits(unit.toFixed(2));
      setSelected(unitBlance);
    } else {
      toast.error("Portfolio not found!")
      setSelected([])
      // selected.length = 0;
      // setSelected(selected);
    }
  };

  const renderData = () => {
    return selected.map((items: any, index: any) => {
      let foundfund = allFunds?.find(
        (fund) => fund.symbol_code === items.fund_code
      );
      return (
        <tr key={index}>
          <td>{items.fund_name ? items.fund_name : "N/A"}</td>
          <td> {items.fund_code ? items.fund_code : "N/A"}</td>
          <td>
            {numberWithCommas(
              parseFloat(
                items.fund_unit
                  ? items.fund_unit.toString().replaceAll(",", "")
                  : "0"
              ).toFixed(4)
            )}
          </td>
          <td>{moment(foundfund?.navData.nav_date).format("DD-MMM-YY")}</td>
          <td>
            {numberWithCommas(
              parseFloat(foundfund?.navData.nav || "0").toFixed(4)
            )}
          </td>
          {/* <td   >{parseFloat(items.nav).toFixed(4)}</td> */}
          <td>
            {numberWithCommas(
              (
                parseFloat(
                  items.fund_unit
                    ? items.fund_unit.toString().replaceAll(",", "")
                    : "0"
                ) * parseFloat(foundfund?.navData.nav.toFixed(4) || "0")
              )
                // parseFloat(
                //   items.nav ? items.nav.toString().replaceAll(",", "") : "0"
                // )
                .toFixed(2)
            )}
          </td>
        </tr>
      );
    });
  };

  const [selected, setSelected] = useState<any>([]);
  const [folio_no, setFolio_no] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [totalUnits, setUnits] = useState("");

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="card">
                <div className="d-flex align-items-center"></div>
                {/* {!loading ? ( */}
                <div className="">
                  <div className="card-header">
                    <h4 className="card-title">Unit Holder Portfolio</h4>
                  </div>
                  <div className="card-body">
                    <div className="row align-items-center">
                      <div className="col-md-4" data-tip="Select Folio">
                        <ReactTooltip
                          textColor="white"
                          backgroundColor="black"
                          effect="float"
                        />

                        <div> Select Folio</div>
                        <Select
                          className="react-select info"
                          label={"Select"}
                          value={
                            allFolios
                              .filter(
                                (item) =>
                                  item.folio_no?.replace("UNITHOLDER_", "") ===
                                  folio_no
                              )
                              ?.map((item) => ({
                                value: item.folio_no?.replace(
                                  "UNITHOLDER_",
                                  ""
                                ),
                                label: item.folio_no?.replace(
                                  "UNITHOLDER_",
                                  ""
                                ),
                              }))[0]
                          } // Take first element instead of array
                          onChange={(selectedOption) => {
                            setSelected([]);
                            setFolio_no(
                              selectedOption ? selectedOption.value : ""
                            ); // Handle null case
                          }}
                          menuPortalTarget={document.body}
                          menuShouldBlockScroll={true}
                          isClearable={true}
                          isSearchable={true}
                          name="color"
                          options={renderAllFoliosDropdown()}
                          styles={customStyles}
                        />
                      </div>

                      <div className="col-md-4">
                        <div className=" ">
                          <button
                            className="btn btn-primary py-2 mt-4 mr-3"
                            disabled={Boolean(loading) || !folio_no}
                            onClick={() => {
                              getUnitHoldersByAmcFolioNo(email, folio_no);
                            }}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Searching...</span>
                              </>
                            ) : (
                              <span>
                                {" "}
                                <i className="fa fa-search mr-2"></i>Search
                              </span>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="">
                      {selected.length > 0 ? (
                        <table className="table mt-3">
                          <thead>
                            <tr>
                              <th>Fund Name</th>
                              <th>Fund Code</th>
                              <th>Units Held</th>
                              <th>NAV as on</th>
                              <th>NAV</th>
                              {/* <th   >NAV</th> */}
                              <th>Total Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {renderData()}
                            <tr className="border-top">
                              <td>
                                <h3>Total</h3>
                              </td>
                              <td></td>
                              <td>{numberWithCommas(totalUnits || 0)}</td>
                              <td></td>
                              <td></td>
                              <td>{numberWithCommas(totalAmount || 0)}</td>
                            </tr>
                          </tbody>
                        </table>
                      ) : unitLoading ? (
                        ""
                      ) : (
                        <div className="table-empty">
                          <BsTable className="icon" />
                          {folio_no === "" ? (
                            <p className="text-center empty-text">
                              Select Unit Holder
                            </p>
                          ) : (
                            <p className="text-center empty-text">Empty</p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* ) : (
            <div className="d-flex justify-content-center my-5">
             <i className="fa fa-spinner fa-spin fa-3x" ></i> 
            </div>
          )} */}
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UnitholderPortfolio;
